import fondo from '../img/fond.webp';
import img from '../img/ecommerce.png';
import '../css/secciones.css'




const Ecommerce = () => {
  return (
    <section className='seccionContainer' id='ecommerce'>
      <img src={fondo} className='fondo' alt='fondo' />
      <div className='cardAnimation'>
        <h2 className='title'>Ecommerce</h2>
      </div>
      <div className='dataContainer'>
        <img src={img} alt='ecommerce' />
        <div className='parrafoContainer'>
          <p className='parrafo'>
            Lanzá tu tienda online con todo lo que necesitás para vender.
            Nuestro servicio de creación de eCommerce combina diseño intuitivo, 
            funcionalidades avanzadas y una plataforma fácil de gestionar. Te ofrecemos 
            una solución completa para mostrar tus productos, atraer clientes y aumentar 
            tus ventas desde cualquier dispositivo.</p>
          <a className='info' href='https://wa.me/5491126134318?text=Hola, me gustaria consultar por un Ecommerce.' target='blank' ><button>
    <span>Más información</span>
  </button></a>
        </div>
      </div>
    </section>
  )
}

export default Ecommerce